module.exports = __webpack_public_path__ + "img/mercury.07c18e54.svg";